module.exports = __webpack_public_path__ + "img/partner09.3e33f91c.png";